import React, { Component } from "react";
// import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import PinchZoomPan from "react-image-zoom-pan";

import "./css/PanAndZoom.css";

export default class PanAndZoomPc extends Component {
  state = {
    minScale: 1,
    maxScale: 3,
    initialScale: 1,
    position: "center",
  };

  MouseDowned = () => {
    console.log("MouseDowned");
    this.setState({ onFirst: false });
  };

  render() {
    return (
      <>
        <PinchZoomPan
          maxScale={this.state.maxScale}
          minScale={this.state.minScale}
          initialScale={this.state.minScale}
          zoomButtons={false}
        >
          <div
            className={
              this.props.currentState ? "pan-pc-main-with-top" : "pan-pc-main"
            }
          >
            <div>
              <img
                className="pan-pc-image-top"
                src={this.props.currentBatten}
                alt="Batten"
              />
            </div>
            <div>
              <img
                className="pan-pc-image-bottom"
                src={this.props.currentFloor}
                alt="Floor"
              />
            </div>
          </div>
        </PinchZoomPan>
      </>
    );
  }
}
